import { Box } from '@coolblue-development/becky';
import { Input, InputAdornment } from '@coolblue-development/freddy';
import CopyContactIdButton from '../CopyContactIdButton/CopyContactIdButton';
import { Divider } from '@mui/material';

export interface OutboundEmailFields {
  to: string;
  subject: string;
  cc?: string;
}

interface EmailOutboundHeaderProps {
  contactId: string;
  fields: OutboundEmailFields;
  onChange: (fields: OutboundEmailFields) => void;
}

const EmailOutboundHeader = ({ contactId, fields, onChange }: EmailOutboundHeaderProps): JSX.Element => {
  const handleChange = (field: keyof OutboundEmailFields) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const updatedFields = { ...fields, [field]: e.target.value };
    onChange(updatedFields);
  };

  return (
    <Box
      sx={{
        border: '1px solid #DDDDDD',
        borderRadius: '4px 4px 0 0',
        display: 'flex',
        flexDirection: 'column'
      }}
      data-testid="outbound-header"
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginRight: '10px'
        }}
      >
        <Input
          data-testid="outbound-to"
          type="email"
          value={fields.to}
          onChange={handleChange('to')}
          startAdornment={<InputAdornment>To:</InputAdornment>}
          variant="borderless"
        />
        <CopyContactIdButton contactId={contactId} />
      </Box>

      <Divider />
      <Input
        data-testid="outbound-cc"
        value={fields.cc}
        onChange={handleChange('cc')}
        startAdornment={<InputAdornment>Cc:</InputAdornment>}
        variant="borderless"
      />
      <Divider />
      <Input
        data-testid="outbound-subject"
        value={fields.subject}
        onChange={handleChange('subject')}
        startAdornment={<InputAdornment>Subject:</InputAdornment>}
        variant="borderless"
      />
    </Box>
  );
};

export default EmailOutboundHeader;
